export default {
  receivablesManageDialog: {
    title: {
      splitClaim: '拆分认领',
      noSplitClaim: '不拆分认领',
      batchFistClaim: '批量一次认领',
      secondClaimTitle: '半自动二次认领',
    },
    receivablesManage: {
      customerNo: '客户',
      claimPartnerNo: '供应商',
      claimDepartmentNo: '部门',
      receivedType: '收款类别',
      salesOrderNo: '销售合同号',
      purchaseOrderNo: '采购合同号',
      plantingAgreementNo: '种植协议号',
      settleBatchNo: '结算批次',
      receivedDetailType: '收款细类',
      projectCode: '项目编号',
      settlementNo: '结算单号',
    },
    placeholder: {
      customerPlaceholder: '请选择客户',
      claimPartnerNoPlaceholder: '请选择供应商',
      claimDepartmentNoPlaceholder: '请选择部门',
      receivedTypePlaceholder: '请选择收款类别',
      salesOrderNoPlaceholder: '请输入销售合同号',
      purchaseOrderNoPlaceholder: '请输入采购合同号',
      plantingAgreementNoPlaceholder: '请输入种植协议号',
    },
    secondClaim: {
      contractBusinessDepartment: '部门',
      salesContractNo: '销售合同号',
      purchaseContractNo: '采购合同号',
      ladingNo: '提单号',
      ladingTotalAmount: '提单金额',
      isCreditsale: '是否赊销',
      customerNo: '客户',
      receivedType: '收款类别',
      contractTotalAmount: '合同金额',
      totalQuantity: '合同数量',
      d: '合同单价',
      contractCreateDate: '合同创建日期',
      invoiceAmount: '已开发票总金额',
      ladingAmount: '已开提单总金额（B）',
      registerAmount: '已认领总金额',
      ladingRegisterAmount: '已认领提单金额（L）',
      unladingRegisterAmount: '未已认领提单金额（L）',
      ASubC: '未认领金额',
      BSubC: 'B-C',
      hasClaim: '已认领金额',
      noClaim: '未认领金额',
      receivedDetailType: '收款细类',
      projectCode: '项目编号',
      settlementNo: '结算单',
      originReceiveMoneyAmount: '本次认领金额',
    },
    message: {
      noSelDepart: '请先选择部门！',
      rowAmountValidL: '认领的金额不能超过提单金额',
      rowAmountValidC: '认领的金额不能超过合同金额',
    },
  },
};
